import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import PaymentByIdContainer from "../../Componant/organisms/PaymentById";
// import { paymentData } from "../../Componant/organisms/PaymentManagement/DemoData";

function PaymentById() {
  // const { paymentId } = useParams<{ paymentId: string }>();
  // const payment = paymentData.find((service) => service.id === paymentId);
  // const data = undefined;
  // // payment?.serviceType === ServiceType.RENTAL
  // //   ? demoProducts.find((product) => product.id === payment?.productId)
  // //   : demoServices.find((service) => service.id === payment?.serviceId);
  // console.log(paymentId, payment, data);

  // if (!paymentId || payment === undefined || data === undefined)
  //   return (
  //     <div className="page-body">
  //       <Row>
  //         <Col className="d-flex justify-content-center">User Id Not Found</Col>
  //       </Row>
  //     </div>
  //   );
  return (
    <div className="page-body">
      {/* <PaymentByIdContainer
        data={data}
        type={payment.serviceType}
        paymentStatus={payment.status}
      /> */}
      <h1>Payment By Id</h1>
    </div>
  );
}

export default PaymentById;
